import React from 'react';
import { ArrowRight, Play } from 'lucide-react';
import { Button } from './ui/button';
import { useContent } from '../i18n/LanguageContext';

const FLAG_POS = {
  fr: { left: '39.5%' },
  en: { left: '42%' },
  de: { left: '44.5%' },
};

export default function Hero({ onDemo, onVideo }) {
  const c = useContent();
  const h = c.hero;  return (
    <section id="top" className="relative hero-gradient overflow-hidden pt-20 md:pt-24 pb-12 md:pb-14">
      <div className="absolute inset-0 grid-dots opacity-70 pointer-events-none" />
      <div className="lt-container relative">
        {/* Badge */}
        <div className="text-center reveal in">
          <span className="inline-flex items-center gap-2 rounded-full border border-teal-200 bg-white/70 px-3.5 py-1.5 text-xs font-semibold text-teal-700">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full rounded-full bg-teal-500 opacity-75 animate-ping" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-teal-600" />
            </span>
            {h.badge}
          </span>
        </div>

        {/* Banner image (full) */}
        <div className="relative mt-8 max-w-6xl mx-auto reveal in">
          <div className="absolute -inset-3 md:-inset-4 rounded-[2.5rem] bg-gradient-to-br from-teal-200/50 to-cyan-200/40 blur-xl" />
          <img
            src={c.heroImage}
            alt="LOGITAG — suivi d'actifs IoT en Suisse"
            className="relative w-full h-auto rounded-[1.5rem] md:rounded-[2rem] shadow-2xl shadow-teal-900/15 border border-white"
          />
          <span
            data-testid="hero-swiss-flag"
            className="absolute z-10 -translate-x-1/2 -translate-y-1/2 rounded-[3px] shadow-md ring-1 ring-black/10 overflow-hidden"
            style={{ left: FLAG_POS[c.lang]?.left || FLAG_POS.fr.left, top: '43.5%', width: '4%', aspectRatio: '1 / 1' }}
            aria-hidden="true"
          >
            <svg viewBox="0 0 32 32" className="w-full h-full block">
              <rect width="32" height="32" fill="#D52B1E" />
              <rect x="13" y="6" width="6" height="20" fill="#fff" />
              <rect x="6" y="13" width="20" height="6" fill="#fff" />
            </svg>
          </span>
        </div>

        {/* CTAs */}
        <div className="mt-10 flex flex-wrap items-center justify-center gap-4 reveal in">
          <Button onClick={onDemo} className="btn-shine h-12 px-7 text-base bg-teal-600 hover:bg-teal-700 text-white rounded-full">
            {c.cta.demo}<ArrowRight className="ml-2 w-5 h-5" />
          </Button>
          <button onClick={onVideo} className="group inline-flex items-center gap-3 h-12 px-3 pr-5 rounded-full border border-slate-200 bg-white hover:border-teal-300 transition-colors">
            <span className="grid place-items-center w-9 h-9 rounded-full bg-teal-600 text-white group-hover:scale-110 transition-transform">
              <Play className="w-4 h-4 ml-0.5" fill="currentColor" />
            </span>
            <span className="text-sm font-semibold text-slate-800">{c.cta.video}</span>
          </button>
        </div>

        {/* KPIs */}
        <div className="mt-10 grid grid-cols-3 gap-4 md:gap-8 max-w-2xl mx-auto reveal in">
          {h.stats.map((s) => (
            <div key={s.label} className="text-center">
              <div className="font-display text-2xl md:text-3xl font-bold text-slate-900">{s.value}</div>
              <div className="text-xs md:text-sm text-slate-500 mt-1 leading-tight">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
